export enum FinalidadeDocumentoMedsusEnum {
  NAO_INFORMADO,
  SOLICITACAO,
  DISPENSACAO,
}

// Mapeamento para exibição amigável
export const FinalidadeDocumentoMedsusLabels: Record<
  FinalidadeDocumentoMedsusEnum,
  string
> = {
  [FinalidadeDocumentoMedsusEnum.NAO_INFORMADO]: 'Não informado',
  [FinalidadeDocumentoMedsusEnum.SOLICITACAO]: 'Solicitação',
  [FinalidadeDocumentoMedsusEnum.DISPENSACAO]: 'Dispensação/Fornecimento',
};

// Mapeamento para códigos/slugs (se necessário para URLs, etc.)
export const FinalidadeDocumentoMedsusCodes: Record<
  FinalidadeDocumentoMedsusEnum,
  string
> = {
  [FinalidadeDocumentoMedsusEnum.NAO_INFORMADO]: 'NI',
  [FinalidadeDocumentoMedsusEnum.SOLICITACAO]: 'D',
  [FinalidadeDocumentoMedsusEnum.DISPENSACAO]: 'E',
};

export const getFinalidadeDocumentoMedsusOptions = () => {
  return Object.values(FinalidadeDocumentoMedsusEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as FinalidadeDocumentoMedsusEnum,
      label:
        FinalidadeDocumentoMedsusLabels[value as FinalidadeDocumentoMedsusEnum],
      code: FinalidadeDocumentoMedsusCodes[
        value as FinalidadeDocumentoMedsusEnum
      ],
    }));
};

export const getFinalidadeDocumentoMedsusLabel = (
  finalidadeDocumentoMedsus: FinalidadeDocumentoMedsusEnum,
): string => {
  return (
    FinalidadeDocumentoMedsusLabels[finalidadeDocumentoMedsus] ||
    'Status Desconhecido'
  );
};

export const getFinalidadeDocumentoMedsusSlug = (
  finalidadeDocumentoMedsus: FinalidadeDocumentoMedsusEnum,
): string => {
  return (
    FinalidadeDocumentoMedsusCodes[finalidadeDocumentoMedsus] || 'Desconhecido'
  );
};

export const getFinalidadeDocumentoMedsusPorCodigo = (
  code: string,
): FinalidadeDocumentoMedsusEnum | undefined => {
  const entry = Object.entries(FinalidadeDocumentoMedsusCodes).find(
    ([, value]) => value === code,
  );
  return entry
    ? (Number(entry[0]) as FinalidadeDocumentoMedsusEnum)
    : undefined;
};

export const getFinalidadeDocumentoMedsusSlugPorValue = (
  value: number | string,
): string => {
  const numericValue = typeof value === 'string' ? Number(value) : value;
  return (
    FinalidadeDocumentoMedsusCodes[
      numericValue as FinalidadeDocumentoMedsusEnum
    ] || 'Desconhecido'
  );
};

export const getFinalidadeDocumentoMedsusLabelPorSlug = (
  slug: string,
): string => {
  const entry = Object.entries(FinalidadeDocumentoMedsusCodes).find(
    ([, value]) => value === slug,
  );
  if (entry) {
    const key = Number(entry[0]) as FinalidadeDocumentoMedsusEnum;
    return FinalidadeDocumentoMedsusLabels[key] || 'Não informado';
  }
  return 'Não informado';
};
